module.exports = __webpack_public_path__ + "img/thermometer-title.ee31a26b.png";